module.exports = __webpack_public_path__ + "img/nbus_container_4_title_mo.e28441a2.jpg";